/**
* ドロワーのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
* @param {options} object - オプション
*/
module.exports = OpenDrawer = function(el, options){
  this.element = $(el);
  this.breakpoint = (options.bp) ? options.bp : 1024;
  this.init();
};

/**
* initialize
*/
OpenDrawer.prototype.init = function(){
  this.win = $(window);
  this.body = $('body');
  this.btn = $('.js-drawer-btn');
  this.overlay = $('.js-drawer-overlay');
  this.drawer = this.btn.next();
  this.event();
};

/**
* event
*/
OpenDrawer.prototype.event = function(){
  var self = this;

  self.btn.prop('checked', false).on('change', function(e){
    var $drawer = $(this).next();
    var direction = $(this).data('drawer-direction');
    // var $elements = self.element.add(self.overlay);
    var $elements = self.overlay;

    if($(this).prop('checked')){
      self.openDrawer($drawer, direction, $elements);
    }else{
      self.closeDrawer($elements);
    }
  });

  self.overlay.on('click', function(e){
    e.preventDefault();
    var $elements = [self.element, self.drawer, $(this)];
    self.closeDrawer($elements);
    self.btn.prop('checked', false);
  });

  var timer = false;
  self.win.on('resize', function() {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      if (self.win.width() >= self.breakpoint && self.btn.prop('checked')) {
        self.overlay.trigger('click');
      }
    }, 200);
  });
};

/**
* open drawer
*/
OpenDrawer.prototype.openDrawer = function(drawer, direction, elms){
  var self = this;
  self.scrollTop = self.win.scrollTop();
  self.body.css({'top': -self.scrollTop});

  var drawerWidth = this.getDrawerWidth();
  var translateValue = (direction === 'left') ? drawerWidth + 'px, 0' : '-' + drawerWidth + 'px, 0';
  var drawerStyles = {};
  drawerStyles.transform = 'translate(' + translateValue + ')';
  drawerStyles['margin-' + direction] = '-' + drawerWidth + 'px';
  $(drawer).css(drawerStyles);
  // $(elms).css('transform', 'translate('+translateValue+')');
  self.body.addClass('is-locked');
  self.overlay.addClass('is-visible');
};

/**
* close drawer
*/
OpenDrawer.prototype.closeDrawer = function(array){
  var self = this;
  for(var i = 0; i < array.length; i++){
    array[i].removeAttr('style');
  }
  self.body.removeClass('is-locked');
  self.overlay.removeClass('is-visible');

  self.body.css({'top': ''});
  self.win.scrollTop(self.scrollTop);
};

/**
* get drawer width
*/
OpenDrawer.prototype.getDrawerWidth = function(){
  return this.drawer.outerWidth();
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/openDrawer.js
// module id = 1
// module chunks = 0